
import { questionService } from "../../../services/question/question.service";
import { questionConstants } from "../../../constants/question/question.constants";
import { alertActions } from "../alert.action";

export const questionActions = {
    getAllQuestionsByEvent,
    updateQuestion,
    createQuestion,
    updateQuestions,
    deleteQuestion
};



function getAllQuestionsByEvent(eventId, includeInherited = false) {
    return dispatch => {
        dispatch(request());
        dispatch(alertActions.clear());
        questionService.getAllQuestionsByEvent(eventId, includeInherited).then(
            questions => {
                dispatch(success(questions));
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    };

    function request() {
        return { type: questionConstants.GET_QUESTION_BY_EVENT_REQUEST };
    }
    function success(questions) {
        return { type: questionConstants.GET_QUESTION_BY_EVENT_SUCCESS, questions };
    }
    function failure(error) {
        return { type: questionConstants.GET_QUESTION_BY_EVENT_FAILURE, error };
    }
}
/**
 * 
 * @param {Question} question 
 * @returns same question object sent in, after sending it to server for saving
 */
function updateQuestion(question) {
    return dispatch => {
        dispatch(request());
        dispatch(alertActions.clear());
        questionService.updateQuestion(question).then(
            _ => {
                dispatch(success(question));
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    };

    function request() {
        return { type: questionConstants.UPDATE_QUESTION_REQUEST };
    }
    function success(question) {
        return { type: questionConstants.UPDATE_QUESTION_SUCCESS, question };
    }
    function failure(error) {
        return { type: questionConstants.UPDATE_QUESTION_FAILURE, error };
    }

}
function updateQuestions(q) {
    return dispatch => {
        dispatch(request());
        dispatch(alertActions.clear());
        questionService.updateRange(q).then(
            questions => {
                dispatch(success(q));
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    };

    function request() {
        return { type: questionConstants.UPDATE_QUESTIONS_REQUEST };
    }
    function success(questions) {
        return { type: questionConstants.UPDATE_QUESTIONS_SUCCESS, questions };
    }
    function failure(error) {
        return { type: questionConstants.UPDATE_QUESTIONS_FAILURE, error };
    }

}
function deleteQuestion(questionId) {
    return dispatch => {
        dispatch(request());
        dispatch(alertActions.clear());
        questionService.deleteQuestion(questionId).then(
            questionId => {
                dispatch(success(questionId));
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    };

    function request() {
        return { type: questionConstants.DELETE_QUESTIONS_REQUEST };
    }
    function success(questionId) {
        return { type: questionConstants.DELETE_QUESTIONS_SUCCESS, questionId };
    }
    function failure(error) {
        return { type: questionConstants.DELETE_QUESTIONS_FAILURE, error };
    }

}

function createQuestion(qs) {
    return dispatch => {
        dispatch(request());
        dispatch(alertActions.clear());
        questionService.create(qs).then(
            question => {
                dispatch(success(question));
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    };

    function request() {
        return { type: questionConstants.CREATE_QUESTION_REQUEST };
    }
    function success(question) {
        return { type: questionConstants.CREATE_QUESTION_SUCCESS, question };
    }
    function failure(error) {
        return { type: questionConstants.CREATE_QUESTION_FAILURE, error };
    }

}
